import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CompanyConfiguration } from '@app-config/models/company-configuration';
import { MessageInfo } from '@comments/store/models/message-info';

import { DateConstants } from '@core-constants/dates/date.constants';
import { ListingDetailsSectionName } from '@listings/enums/listing-details-section-name';
import { ListingDetailsNavigationParams } from '@listings/models/events/listing-details-navigation-params';
import { MediaViewerInitialParams } from '@media/components/media-viewer/models/media-viewer-initial-params';
import { GalleryListingCardComponent } from '../../../view-modules/view-base/components/gallery-listing-card/gallery-listing-card.component';
import { RpcIconComponent } from '../../../core-modules/utils/rpc-icon/rpc-icon.component';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'landing-message-card',
    templateUrl: './landing-message-card.component.html',
    styleUrls: ['./landing-message-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [GalleryListingCardComponent, RpcIconComponent, DatePipe]
})
export class LandingMessageCardComponent {
    @Input() public messageInfo: MessageInfo;
    @Input() public shouldHideOpenRentals: boolean;
    @Input() companyConfiguration: CompanyConfiguration;

    @Output() public mediaViewerClicked = new EventEmitter<MediaViewerInitialParams>();
    @Output() public listingDetailsClicked = new EventEmitter<ListingDetailsNavigationParams>();

    public readonly dateConstants = DateConstants;

    public onMediaViewerClicked(mediaViewerClickedEventParams: MediaViewerInitialParams): void {
        this.mediaViewerClicked.emit(mediaViewerClickedEventParams);
    }

    public onMessageCardClicked(): void {
        this.listingDetailsClicked.emit({ listingId: this.messageInfo.listing.id, tabId: ListingDetailsSectionName.Comments });
    }
}
